/**
 * @fileoverview GET handler for the "/engagement/landing_pages_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { createTableFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createTableFetcherFunctionWithShadowError";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesData } from "./constants";
import type {
  EngagementLandingPagesDataParams,
  EngagementLandingPagesDataResult,
  LandingPageErrors,
} from "./types";

export const getDataTableEngagementLandingPagesData = reactQueryTableFetcherAdapter(
  engagementLandingPagesData,
  createTableFetcherFunctionWithShadowError<LandingPageErrors>()(
    (
      signal: AbortSignal,
      { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementLandingPagesDataParams
    ): Promise<EngagementLandingPagesDataResult> => {
      return fetch(
        "/engagement/landing_pages_data",
        "GET",
        {
          groupby,
          limit,
          sortby,
          sortdir,
          start,
          app_group_id: appGroupId,
          query: serializeQueryObjects(query),
        },
        { signal }
      );
    }
  )
);
